import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CHECKOUT_URL, BUY_ANCHOR } from '../utils/constants';
import { CtaButton } from './CtaButton';
const INCLUDED = ['Complete 6-Module Professional Teaching System', '5 Strategic Bonuses', 'Ready-to-Use Visual Supports', 'Adaptable Activity Library', 'Differentiation Toolkit', 'Classroom Routine Systems', 'Planning & Progress Resources', 'Ready-to-Use Resource Vault', 'Lifetime Access', 'Instant Digital Delivery'];
export function Pricing() {
  return <section id={BUY_ANCHOR} aria-labelledby="pricing-title" className="w-full scroll-mt-14 bg-white px-3 py-7 sm:px-5" data-id="element-141" data-mp="1ru15sf3w82cc">
      <div className="mx-auto max-w-xl text-center" data-id="element-142" data-mp="25q4y22v7i0m6">
        <h2 id="pricing-title" className="font-head text-2xl uppercase leading-[0.98] text-ink sm:text-4xl" data-id="element-143" data-mp="20s3bh7yknj5y">
          Everything included. One single price.
        </h2>
        <p className="mt-1 text-[13px] text-muted" data-id="element-144" data-mp="3c8jutcd8yjy3">No subscriptions. No hidden charges.</p>

        <div className="mt-3 overflow-hidden rounded-2xl border-2 border-petrol bg-cream text-left" data-id="element-145" data-mp="3vzgqbjhz8sun">
          <div className="bg-petrol px-4 py-3 text-center text-white" data-id="element-146" data-mp="4svttk95ksq8">
            <h3 className="font-head text-base uppercase leading-tight sm:text-xl" data-id="element-147" data-mp="4v8kclsz8bew">
              Special Education Teacher Pro™ — Complete Box Set
            </h3>
            <p className="mt-0.5 text-[11px] text-white/80 sm:text-sm" data-id="element-148" data-mp="eq0jvv64d8cb">
              1 Main Box Set With 6 Modules + 5 Strategic Bonuses
            </p>
          </div>

          <div className="p-4" data-id="element-149" data-mp="3i7iprx2c05a3">
            <p className="font-head text-[11px] uppercase tracking-widest text-muted" data-id="element-150" data-mp="3i8tuq07ijj2s">
              What’s Included
            </p>
            <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-151" data-mp="3n5ahapz2dpdr">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] leading-snug text-body" data-id="element-152" data-mp="3rz6cjkny0y58">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-cta" aria-hidden="true" data-id="element-153" data-mp="2ugdc9ojv5p2y" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-3 rounded-xl bg-white p-3 text-center" data-id="element-154" data-mp="2rfteafn1prhr">
              <p className="text-[13px] text-muted" data-id="element-155" data-mp="2mi1j9cr3tp9c">
                Regular Price: <span className="line-through" data-id="element-156" data-mp="2mfp6de07e535">$97 USD</span>
              </p>
              <p className="font-head text-4xl leading-none text-petrol sm:text-5xl" data-id="element-157" data-mp="3164vh3vqpx6l">$27 USD</p>
              <span className="mt-1 inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[11px] uppercase tracking-wide text-white" data-id="element-158" data-mp="2w83c0huejvul">
                Save $70
              </span>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-159" data-mp="23k7fbd4u23xt">
                One-Time Payment · Lifetime Access
              </p>
            </div>

            <div className="mt-3 flex flex-col items-center" data-id="element-160" data-mp="2dgtyzylfaoy9">
              <CtaButton href={CHECKOUT_URL} data-id="element-161" data-mp="2djg47rkucsdb" />
              <p className="mt-1.5 text-[11px] text-muted" data-id="element-162" data-mp="3tuagzsumbq7h">
                Backed by our 7-day money-back guarantee.
              </p>
              <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted" data-id="element-163" data-mp="3oycz3i3pibsl">
                <li className="flex items-center gap-1" data-id="element-164" data-mp="5ai1ggg2io98">
                  <LockIcon className="h-3 w-3 text-petrol" aria-hidden="true" data-id="element-165" data-mp="3nf376vo2s5xi" />
                  Secure Payment
                </li>
                <li className="flex items-center gap-1" data-id="element-166" data-mp="3rfwx1ul2vut1">
                  <ZapIcon className="h-3 w-3 text-petrol" aria-hidden="true" data-id="element-167" data-mp="3rihxcf5qa2oo" />
                  Instant Access
                </li>
                <li className="flex items-center gap-1" data-id="element-168" data-mp="o07vv2fx580m">
                  <CreditCardIcon className="h-3 w-3 text-petrol" aria-hidden="true" data-id="element-169" data-mp="o22l2sy83mai" />
                  Card · Google Pay · Apple Pay
                </li>
              </ul>
              <p className="mt-0.5 text-[10px] text-muted" data-id="element-170" data-mp="e8lndduytn1k">
                You will be charged in your local currency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}